import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Slider,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { formatDollarAmountWithoutDecimal } from '../../utilities/formatters';

type ConciergeEnabledWorkOrderModuleProps = {
  conciergeEnabled: boolean;
  setConciergeEnabled: Dispatch<SetStateAction<boolean>>;
  maxBudget: number;
  setMaxBudget: (value: number) => void;
};

export function ConciergeEnabledWorkOrderModule(props: ConciergeEnabledWorkOrderModuleProps) {
  const theme = useTheme();
  return (
    <Grid container sx={[{ backgroundColor: theme.palette.secondary.light }, styles.mainContainer]}>
      <Grid item xs={12}>
        <Typography>Want bids from ProCure?</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant={'caption'}>
          {
            "Finding vendors can be challenging. We'll help you source bids, coordinate onsite visits, and present the best options."
          }
        </Typography>
      </Grid>
      <Grid container item xs={12} sx={styles.subContainer}>
        <RadioGroup
          row
          value={props.conciergeEnabled}
          onChange={e => props.setConciergeEnabled(e.target.value === 'true')}
        >
          <FormControlLabel value={true} control={<Radio />} label='Yes' />
          <FormControlLabel value={false} control={<Radio />} label='No' />
        </RadioGroup>
      </Grid>

      {props.conciergeEnabled && (
        <>
          <Grid container item xs={12} sx={styles.payContainer}>
            <Typography variant={'body2'}>{"I'm expecting to pay:"}</Typography>
            <Typography variant={'body2'}>
              {formatDollarAmountWithoutDecimal(props.maxBudget)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2} direction='row' sx={styles.sliderContainer} alignItems='center'>
              <Typography>{'$1,000'}</Typography>
              <Slider
                defaultValue={props.maxBudget}
                getAriaValueText={(value, index) => String(value)}
                value={props.maxBudget}
                onChange={(event, value) => props.setMaxBudget(Number(value))}
                step={100}
                min={1000}
                max={10000}
              />
              <Typography>{'$10,000'}</Typography>
            </Stack>
          </Grid>
        </>
      )}
    </Grid>
  );
}

const styles = {
  mainContainer: {
    border: '1px solid black',
    padding: 4,
    borderRadius: 2,
    rowGap: 2,
  },
  subContainer: {
    justifyContent: 'center',
  },
  payContainer: {
    justifyContent: 'space-between',
  },
  sliderContainer: {
    mb: 1,
    width: '100%',
  },
};
